import React, { useState, useEffect } from 'react'
import { Box } from 'grommet'
import { useIsPremium } from '../../hook/useIsPremium'
// import styled from "styled-components"

// const RelativeBox = styled(Box)`
//   position: relative;
//   & *:not(:last-child) {
//     display: none;
//   }
// `

// const AbsoluteText = styled(Text)`
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   margin-top: -5px;
// `
/* {props.adText ? <AbsoluteText>Advertisement</AbsoluteText> : null} */

const Adthrive = ({ children, id, ...rest }) => {
  const { isPremium, isSharePremium } = useIsPremium()
  const [showPremium, setShowPremium] = useState(false)
  // const showPremium = isPremium || premiumHistory
  const idText = showPremium ? 'Premium' : ''
  useEffect(() => {
    if (!showPremium) {
      //only can change from non premium to premium, but can't reverse. To maintain box id
      const premium = isPremium || isSharePremium
      setShowPremium(premium)
    }
  }, [isPremium, isSharePremium])

  return (
    <>
      {typeof window === 'undefined' ||
      process.env.GATSBY_BUILD_CONTEXT === 'development' ||
      showPremium ? (
        <Box id={`${id}${idText}`} {...rest}>
          {children}
        </Box>
      ) : (
        <div
          id={id}
          dangerouslySetInnerHTML={{
            __html: '',
          }}
          //   suppressHydrationWarning
        />
      )}
    </>
  )
}

export default Adthrive
